import { v4 as uuid } from "uuid";

import { tReduxAction } from "../types";
import {
  tCloseModalAction,
  tCloseTooltipAction,
  tModal,
  tModalResponse,
  tOpenModalAction,
  tOpenTooltipAction,
  tToggleTooltipAction,
  tTooltip,
} from "./types";

export const openModal = <P = unknown, D = unknown>({
  id,
  component,
  props,
}: tModal<P, D>): tReduxAction<void, tOpenModalAction<P, D>> => {
  return (dispatch) => {
    dispatch({ type: "OPEN_MODAL", payload: { id, component, props } });
  };
};

export const openModalAsync = <P = void, D = void>(
  component: tModal<P, D>["component"],
  props: P,
): tReduxAction<Promise<tModalResponse<D>>> => {
  return (dispatch) => {
    const id = uuid();
    return new Promise<tModalResponse<D>>((resolve, reject) => {
      dispatch(openModal({ id, component, props: { ...props, onResolve: resolve, onReject: reject } }));
    });
  };
};

export const closeModal =
  (id: string): tReduxAction<void, tCloseModalAction> =>
  (dispatch) =>
    dispatch({ type: "CLOSE_MODAL", payload: id });

export const openTooltip =
  (payload: Omit<tTooltip, "isOpen">): tReduxAction<void, tOpenTooltipAction> =>
  (dispatch) =>
    dispatch({ type: "OPEN_TOOLTIP", payload: { ...payload, isOpen: true } });

export const toggleTooltip =
  (payload: Omit<tTooltip, "isOpen">): tReduxAction<void, tToggleTooltipAction> =>
  (dispatch) =>
    dispatch({ type: "TOGGLE_TOOLTIP", payload });

export const closeTooltip = (): tReduxAction<void, tCloseTooltipAction> => (dispatch) =>
  dispatch({ type: "CLOSE_TOOLTIP" });
